import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle, faExclamationTriangle, faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import classnames from "classnames";

const NotificationBar = ({ className, message, type = "info", variant, link, linkText, children }) => {
    const classes = classnames("notification-bar", className, {
        "-error": type === "error",
        "-warning": type === "warning",
        "-success": type === "success",
        "-info": type === "info",
    });
    const iconClasses = classnames("icon", "flex", {
        "-small": variant === "small",
    });

    let icon;
    switch (type) {
        case "error":
            icon = <FontAwesomeIcon icon={faExclamationTriangle} />;
            break;
        case "warning":
            icon = <FontAwesomeIcon icon={faExclamationTriangle} />;
            break;
        case "success":
            icon = <FontAwesomeIcon icon={faCheckCircle} />;
            break;
        default:
            icon = <FontAwesomeIcon icon={faInfoCircle} />;
    }
    const url = link ? (
        <a
            href={link}
            target="_blank"
            rel="noopener noreferrer"
        >
            {linkText}
        </a>
    ) : null;

    const body = children ? (
        children
    ) : (
        <strong>
            {message} {url}
        </strong>
    );

    return (
        <div className={classes}>
            {body}
            <div className={iconClasses}>{icon}</div>
        </div>
    );
};

export default NotificationBar;
